// ************************
// 共通: H1 の種別リスト
// ************************
var BAND_H1_LIST = ['h1_SC', 'h1_SL', 'h1_AWCB', 'h1_AWLB'];
// スクエアケース系マグネットファミリー（なし / Pixelsnap / SnapMag / MagSafe）
var MAGNET_H1_LIST = ['h1_FN', 'h1_FP', 'h1_FS', 'h1_MS']; 
// ★プレミアムパネル系マグネットファミリー（なし / Pixelsnap / MagSafe）
//   ・h1_PN = リングなし（handle: pn_pl_...）
//   ・h1_PP = Pixelsnap リング（同系列想定）
//   ・h1_PM = MagSafe リング（handle: pm_ms_...）
//   ※もし実タグが異なる場合はこの配列だけ直せば全体が追従します
var PANEL_MAGNET_H1_LIST = ['h1_PN', 'h1_PP', 'h1_PM'];

// base_h1_code が属するマグネットファミリー配列を返す（無ければ null）
function getMagnetFamilyList(baseH1) {
  if (MAGNET_H1_LIST.indexOf(baseH1) > -1) return MAGNET_H1_LIST;
  if (PANEL_MAGNET_H1_LIST.indexOf(baseH1) > -1) return PANEL_MAGNET_H1_LIST;
  return null;
}
// そのファミリーにおける「リングなし」の h1 コードを返す
function getMagnetNoneCode(baseH1) {
  if (MAGNET_H1_LIST.indexOf(baseH1) > -1) return 'h1_FN';
  if (PANEL_MAGNET_H1_LIST.indexOf(baseH1) > -1) return 'h1_PN';
  return null;
}
// プレミアムパネル系かどうか
function isPanelMagnet(baseH1) {
  return PANEL_MAGNET_H1_LIST.indexOf(baseH1) > -1;
}
var MAGNET_COLOR_MAP = {
  // Pixelsnap
  m_PW: 'ホワイト',
  m_PB: 'ブラック',
  m_NW: 'ホワイト',
  m_NB: 'ブラック',
  // MagSafe
  m_GW: 'ホワイト',
  m_GB: 'ブラック',
  m_AW: 'ホワイト',
  m_AB: 'ブラック',
  // SnapMag
  m_IW: 'ホワイト',
  m_IB: 'ブラック',
  m_UW: 'ホワイト',
  m_UB: 'ブラック',
  // ★プレミアムパネル用リング（Pixelsnap: m_PS/m_PK / MagSafe: m_MS/m_MK）
  m_PS: 'ホワイト',
  m_PK: 'ブラック',
  m_MS: 'ホワイト',
  m_MK: 'ブラック'
};
var SPCC_GROUP = ['h1_SP', 'h1_CC'];

// h1_BC は「ケース商品」としては扱わないが、ケースタイプ・ケースカラーの切り替えだけ表示する
var CASE_SELECTOR_ONLY_H1_LIST = ['h1_BC'];

// メーカー・機種セレクトを非表示にする商品種別
var MODEL_HIDDEN_H1_LIST = ['h1_TB', 'h1_BC'];

function isSpCc(baseH1) {
  return SPCC_GROUP.indexOf(baseH1) > -1;
}

// ★グローバル版：cscl_ から「リング/付属の文言」を除きフレームカラーだけにする
//   setupModelFiltering など $(document).ready の外からも使えるようにここで定義する
function normalizeCaseColorTag(case_color) {
  if (!case_color) return null;
  var val = case_color.replace(/^cscl_/, '');
  val = val
    .replace(/withホワイトリング/g, '')
    .replace(/withブラックリング/g, '')
    .replace(/withホワイト/g, '')
    .replace(/withブラック/g, '')
    .replace(/（ホワイト付き）/g, '')
    .replace(/（ブラック付き）/g, '');
  val = val.trim();
  return 'cscl_' + val;
}

window.fox = window.fox || {};
window.fox.settings = window.fox.settings || {};

window.ACCESSORY_QUERY_MODEL  = window.ACCESSORY_QUERY_MODEL  || 'MODEL';
window.ACCESSORY_QUERY_DESIGN = window.ACCESSORY_QUERY_DESIGN || 'DESIGN';

window.theme_accessToken = window.theme_accessToken || window.theme_accessToken;

function getH1CaseMap() {
  return (window.fox && window.fox.settings && window.fox.settings.h1case) || {};
}

// ラベルに「ケース」or「Case」を含む h1_ を全部スマホケース扱いするヘルパー
function getPhoneCaseH1List() {
  var h1caseMap = getH1CaseMap();

  return Object.keys(h1caseMap).filter(function (key) {
    var label = h1caseMap[key] || '';
    return (
      (label.indexOf('ケース') !== -1 || label.indexOf('Case') !== -1) &&
      BAND_H1_LIST.indexOf(key) === -1
    );
  });
}
function getProductJsonSafe() {
  var el = document.querySelector('.js-section-product');
  if (el) {
    var raw = el.getAttribute('data-product-json');
    if (raw) {
      try { return JSON.parse(raw); } catch (e) {}
    }
  }

  var p = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
  if (p) return p;

  return {};
}

function getTagsSafe() {
  var p = getProductJsonSafe();
  return Array.isArray(p.tags) ? p.tags : [];
}
$(document).ready(function () {
  var tags = getTagsSafe();
  var product_json = getProductJsonSafe();
  
  if (!tags.length) {
    console.warn('[init] tags empty -> stop init');
    return;
  }
  var ACCESS_TOKEN_STORE_FRONT_API = theme_accessToken;

  // h1case の取得を安全に
  var h1caseMap = getH1CaseMap();
  var caseH1Tags = Object.keys(h1caseMap);

  // h1_ のベースタグを1回だけ取得
  var base_h1_code =
    tags.find(function (code) {
      return code.indexOf('h1_') === 0;
    }) || null;
  var isTB = (base_h1_code === 'h1_TB');

  // h1_BC はケース商品扱いにしないが、ケースタイプ・ケースカラーの候補生成には含める
  var isCaseSelectorOnlyProduct = CASE_SELECTOR_ONLY_H1_LIST.indexOf(base_h1_code) > -1;
  var isCaseProduct = caseH1Tags.indexOf(base_h1_code) > -1 && !isCaseSelectorOnlyProduct;
  var isCaseSelectorProduct = isCaseProduct || isCaseSelectorOnlyProduct;
  var selectorCaseH1Tags = caseH1Tags.concat(
    CASE_SELECTOR_ONLY_H1_LIST.filter(function(h1) {
      return caseH1Tags.indexOf(h1) === -1;
    })
  );

  var shouldHideModel = MODEL_HIDDEN_H1_LIST.indexOf(base_h1_code) > -1;

  if (shouldHideModel) {
    // wrapperごと隠す
    $('.selector-container.is-model').addClass('d-none');

    // セレクト自体も念のため非表示＆イベント解除
    $('.series').off('.modelFiltering .we').prop('disabled', true).hide();
    $('.model_selector.models')
      .off('.modelNavigate')
      .prop('disabled', true)
      .hide()
      .empty();

    console.log('[model] hide maker/model selectors:', base_h1_code);
  }
  // ラベルからスマホケース判定用リストを生成
  var PHONE_CASE_H1_LIST = getPhoneCaseH1List();

  // バンド系かどうか
  var isWatchBandType = BAND_H1_LIST.indexOf(base_h1_code) > -1;

  // 「スマホケース商品かどうか」
  var isPhoneCaseProduct = PHONE_CASE_H1_LIST.indexOf(base_h1_code) > -1;

  console.log(
    '[debug] base_h1_code =',
    base_h1_code,
    'isPhoneCaseProduct =',
    isPhoneCaseProduct
  );

  console.log('[debug] base_h1_code =', base_h1_code, 'isPhoneCaseProduct =', isPhoneCaseProduct);

  var design_code = tags.find(function(code) {
    return code.indexOf('h2_') === 0;
  });
  var base_model_code = tags.find(function(code) {
    return code.indexOf('mo_') === 0;
  });
  var base_index_no = tags.find(function(code) {
    return code.indexOf('index_') === 0;
  });
  var base_collection_code = tags.find(function(code) {
    return code.indexOf('col_') === 0;
  });
  var base_material_code = tags.find(function(code) {
    return code.indexOf('m_') === 0;
  });
  var base_player_code = tags.find(function(code) {
    return code.indexOf('pl_') === 0;
  });
  var base_f_code = tags.find(function(code) {
    return code.indexOf('f_') === 0; // note f_ は柄
  });
  var base_case_color = tags.find(function(code) {
    return code.indexOf('cscl_') === 0;
  });
  var base_sling_color = tags.find(function(code) {
    return code.indexOf('slcl_') === 0;
  });
  var base_ribbon_color = tags.find(function(code) {
    return code.indexOf('rbcl_') === 0;
  });
  /* ケースタイプ・ケースカラー選択対象でケースカラーなしの場合はクリアケースとして扱う */
  if (isCaseSelectorProduct && !base_case_color) {
    base_case_color = 'cscl_クリア';
  }
  var normalized_base_case_color = base_case_color
  ? normalizeCaseColorTag(base_case_color)
  : null;

  // キーワードタグのリンク生成
  $('.keyword-tag a').each(function(index, element) {
    var hrefTag = $(element).data('href');
    if (base_model_code && hrefTag) {
      $(element).attr('href', '/collections/all/' + base_model_code + '+' + hrefTag);
    }
  });

  // GraphQL 共通関数
  var get_products_graphql = function(query, callback, cursor) {
    var cursor_query = '';
    if (cursor) {
      cursor_query = ', after: "' + cursor + '"';
    }

    return $.ajax({
      type: 'POST',
      timeout: 8000,
      url: '/api/2024-07/graphql.json',
      headers: {
        'Content-Type': 'application/graphql',
        'X-Shopify-Storefront-Access-Token': ACCESS_TOKEN_STORE_FRONT_API
      },
      data:
        '{ products(query: "' + query + '", first: 250' + cursor_query + ') {' +
          ' edges { cursor, node { ' +
            ' title, id, handle, tags,' +
            ' priceRange { minVariantPrice { amount } },' +
            ' publishedAt, productType,' +
            ' images(first:1) { edges { node { originalSrc } } }' +
          ' } },' +
          ' pageInfo { hasNextPage }' +
        ' } }',
      cache: false
    }).done(function(e) {
      callback(e.data);
    }).fail(function(e) {
      console.error(e);
    });
  };

  var get_all_products_graphql = function(query, callback, all_products, cursor) {
    if (all_products == null) {
      all_products = [];
    }
    get_products_graphql(query, function(data) {
      if (data.products.pageInfo.hasNextPage === true) {
        var edges = data.products.edges;
        var nextCursor = edges.slice(-1)[0].cursor;
        get_all_products_graphql(query, callback, all_products.concat(edges), nextCursor);
      } else {
        callback(all_products.concat(data.products.edges));
      }
    }, cursor || null);
    return true;
  };
  // ============================
  // バンド用 ケースタイプ / カラー選択
  // ============================
  function buildCaseSelectors(products) {
    if (!products || !products.length || !design_code) return;

    var casetype_selector_template_content = $('#js_casetype_selector').html();
    var casetype_selector_template = _.template(casetype_selector_template_content);
    var color_selector_template_content = $('#js_color_selector').html();
    var color_selector_template = _.template(color_selector_template_content);

    var isWatchBandType = BAND_H1_LIST.indexOf(base_h1_code) > -1;

    // 「同じ機種 + 同じ index_ 」の商品だけに絞り込む
    var sameDeviceProducts = products.filter(function (p) {
      var info  = p.node;
      var ptags = info.tags || [];

      var model_code = null;
      var index_no   = null;
      var h1_code    = null;

      for (var i = 0, len = ptags.length; i < len; i++) {
        var code = ptags[i];
        if (!model_code && code.indexOf('mo_') === 0) {
          model_code = code;
        } else if (!index_no && code.indexOf('index_') === 0) {
          index_no = code;
        } else if (!h1_code && code.indexOf('h1_') === 0) {
          h1_code = code;
        }
        if (model_code && index_no && h1_code) break;
      }

      if (!model_code || !index_no || !h1_code) return false;
      if (model_code !== base_model_code || index_no !== base_index_no) return false;

      // バンドのとき：h1_SC / h1_SL だけ、などの既存条件はそのまま下に残す
      if (isWatchBandType) {
        return BAND_H1_LIST.indexOf(h1_code) > -1;
      }
      return selectorCaseH1Tags.indexOf(h1_code) > -1;
    });

    var casetype_selector = {};
    var casecolor_links   = {};
    var magnetring_links  = {};

    // ★現在のページが属するマグネットファミリー（スクエア or パネル）を一度だけ判定
    var magnetFamily   = getMagnetFamilyList(base_h1_code);
    var magnetNoneCode = getMagnetNoneCode(base_h1_code);

    sameDeviceProducts.forEach(function(p) {
      var info  = p.node;
      var ptags = info.tags || [];
      var handle = info.handle;

      var h1_code    = ptags.find(function(code){ return code.indexOf('h1_')    === 0; });
      var case_color = ptags.find(function(code){ return code.indexOf('cscl_')  === 0; });

      // ケースカラーが無いケース → クリア扱い
      if (selectorCaseH1Tags.indexOf(h1_code) > -1 && !case_color) {
        case_color = 'cscl_クリア';
      }

      var img   = (info.images.edges[0] && info.images.edges[0].node.originalSrc) || '';
      var price = Math.floor(Number(info.priceRange.minVariantPrice.amount)).toLocaleString('ja-JP');

      // ---------- ケースタイプ -----------
      if (isWatchBandType) {
        // バンドのとき：
        // 「同じデザイン＋同じ機種＋現在選択中のカラー」の別タイプを並べたいので
        // ・h1_SC / h1_SL のみ対象
        // ・case_color が base_case_color のものだけを拾う
        if ((h1_code === 'h1_SC' || h1_code === 'h1_SL') &&
            case_color === base_case_color &&
            !casetype_selector[h1_code]) {

          var label =
            h1_code === 'h1_SC' ? 'クリアバンド' :
            h1_code === 'h1_SL' ? 'レザーバンド' : '';

          casetype_selector[h1_code] = {
            handle: handle,
            image: img,
            price: price,
            variant_image: img,
            variant_handle: handle,
            active: (h1_code === base_h1_code),
            label: label
          };
        }
      } else {
        if (selectorCaseH1Tags.indexOf(h1_code) > -1) {
          var label = window.fox.settings.h1[h1_code] || '';
          var normalizedCaseColorForType = case_color ? normalizeCaseColorTag(case_color) : null;
          var currentTypeItem = casetype_selector[h1_code];
          var shouldSetCaseType = false;

          if (!currentTypeItem) {
            shouldSetCaseType = true;
          } else if (
            normalized_base_case_color &&
            normalizedCaseColorForType === normalized_base_case_color &&
            currentTypeItem.normalized_case_color !== normalized_base_case_color
          ) {
            // ケースタイプ切り替え時も、可能なら現在のケースカラーに近い商品を優先する
            shouldSetCaseType = true;
          }

          if (shouldSetCaseType) {
            casetype_selector[h1_code] = {
              handle: handle,
              image: img,
              price: price,
              variant_image: img,
              variant_handle: handle,
              active: (h1_code === base_h1_code),
              label: label,
              normalized_case_color: normalizedCaseColorForType
            };
          }
        }
      }

      // ---------- カラー -----------
      if (h1_code === base_h1_code && case_color) {
        // cscl_◯◯ を「フレームだけ」のキーに正規化
        var normalizedColor = normalizeCaseColorTag(case_color);

        // ケースカラーを変えるときは、リングカラー(なし/白/黒)を維持したい
        // → m_タグの完全一致ではなく、MAGNET_COLOR_MAP で色名に変換して比較する
        //   （同じ白でもマウント種別で m_ タグが異なるため。例: Pixelsnap=m_PS / MagSafe=m_MS）
        //   商品が複数の m_ タグ（フレーム素材＋リング）を持つ場合に備え、
        //   MAGNET_COLOR_MAP に載っている m_ タグ（＝リング）だけを色として拾う
        var ringMatches = true;
        if (magnetFamily) {
          var baseRingColor = null;
          tags.forEach(function(t){
            if (t.indexOf('m_') === 0 && MAGNET_COLOR_MAP[t]) baseRingColor = MAGNET_COLOR_MAP[t];
          });
          var nodeRingColor = null;
          ptags.forEach(function(t){
            if (t.indexOf('m_') === 0 && MAGNET_COLOR_MAP[t]) nodeRingColor = MAGNET_COLOR_MAP[t];
          });
          // baseがリング色を持つ場合のみ「同じ色か」を判定（なし同士は null 同士で一致扱い）
          ringMatches = (nodeRingColor === baseRingColor);
        }
        var colorScore = ringMatches ? 2 : 0;

        var currentColorItem = casecolor_links[normalizedColor];
        if (!currentColorItem || colorScore > (currentColorItem._score || -1)) {
          casecolor_links[normalizedColor] = {
            handle: handle, // 代表の1商品（リングが一致するものを優先）
            active: (normalized_base_case_color &&
                    normalizedColor === normalized_base_case_color),
            _score: colorScore
          };
        }
      }

      // ---------- マグネットリング切り替え用 -----------
      // スクエアケース系（MAGNET_H1_LIST）・パネル系（PANEL_MAGNET_H1_LIST）の
      // どちらのファミリーでも同じロジックでリング(なし/白/黒)を組み立てる
      if (magnetFamily && magnetFamily.indexOf(h1_code) > -1) {

        // このノードのフレームカラーが現在と同じか（正規化して比較）
        var normalizedColorForRing = case_color ? normalizeCaseColorTag(case_color) : null;
        var frameMatches = !!(normalized_base_case_color &&
                              normalizedColorForRing === normalized_base_case_color);

        // ① リングなし（ファミリーごとの「なし」コード = h1_FN / h1_PN）
        if (h1_code === magnetNoneCode) {
          var noneScore = frameMatches ? 2 : 0; // 同じフレームの「なし」を優先
          var currentNone = magnetring_links.none;

          if (!currentNone || noneScore > (currentNone._score || -1)) {
            magnetring_links.none = {
              handle: '/products/' + handle,
              color: 'none',                    // ★ テンプレ用クラス
              label: 'リングなし',              // ★ 見出し用ラベル
              active: (base_h1_code === magnetNoneCode), // 今のページが「なし」なら active
              _score: noneScore
            };
          }

        } else {
          // ② ホワイト / ブラック（m_タグから判定。マウント別の色は MAGNET_COLOR_MAP を共用）
          var magnetCode = ptags.find(function(code){ return code.indexOf('m_') === 0; });

          if (magnetCode && MAGNET_COLOR_MAP[magnetCode]) {
            var colorKey   = MAGNET_COLOR_MAP[magnetCode]; // 'ホワイト' or 'ブラック'
            var ringLabel  = (colorKey === 'ホワイト') ? 'ホワイト' : 'ブラック';

            // リング色を変えるときは「フレームカラー・マウントタイプ(h1)」を維持したい
            // → 同じフレーム(+4) > 同じマウントタイプ(+2) の優先度で代表を選ぶ
            var ringScore = 0;
            if (frameMatches)             ringScore += 4;
            if (h1_code === base_h1_code) ringScore += 2;

            var currentRingItem = magnetring_links[colorKey];

            if (!currentRingItem || ringScore > (currentRingItem._score || -1)) {
              magnetring_links[colorKey] = {
                handle: '/products/' + handle,
                color: colorKey,                       // ★ CSS 用クラス名（ホワイト / ブラック）
                label: ringLabel,                     // ★ 見出し用テキスト
                h1_code: h1_code,
                case_color: case_color,
                magnet_code: magnetCode,
                // base の m_タグと同じなら active
                active: (magnetCode === base_material_code),
                _score: ringScore
              };
            }
          }
        }
      }
    });

    // ----------------- マグネットリング（共通） -----------------
    if (Object.keys(magnetring_links).length) {
      var magnetTemplateContent = $('#js_magnetring_selector').html();
      var magnetTemplate       = _.template(magnetTemplateContent);

      $('.selector-container.is-magnetring').removeClass('d-none');
      $('#js_magnetring_container').empty();

      // 表示順を固定：なし → ホワイト → ブラック
      ['none', 'ホワイト', 'ブラック'].forEach(function(key) {
        var item = magnetring_links[key];
        if (!item) return;

        var html = magnetTemplate({
          handle: item.handle,
          color:  item.color,
          active: item.active
        });
        $('#js_magnetring_container').append(html);
      });

      // 現在選択中のラベルをヘッダに表示
      var currentMagnetLabel = '';
      ['none', 'ホワイト', 'ブラック'].forEach(function(key) {
        var item = magnetring_links[key];
        if (item && item.active) {
          currentMagnetLabel = item.label;
        }
      });
      if (currentMagnetLabel) {
        $('#js_magnetring_label').text(currentMagnetLabel);
      }
    }

    // ----------------- ケースタイプ（共通） -----------------
    if (Object.keys(casetype_selector).length) {
      $('.selector-container.is-casetype').removeClass('d-none');
      $('.casetype-container').empty();

      // ★スマホケース商品の場合のみ表示制限を適用
      if (isPhoneCaseProduct) {
        // 表示したいケースタイプとその順番を定義
        const allowedCaseTypes = [
          'スリムプロテクションケース',
          'プレミアムスクエアケース',
          'スリムプロテクションプレミアムケース',
          'スリムプロテクションプレミアムケース with MagSafe ホワイトリング',
          'プレミアムスクエアケース with MagSafe',
          'プレミアムスクエアケース with Pixelsnap',
          'プレミアムスクエアケース with SnapMag'
        ];

        function normalizeCaseTypeDisplayLabel(label) {
          if (!label) return label;
          return label
            .replace(/\s*ホワイトリング\s*$/, '')
            .replace(/\s*ブラックリング\s*$/, '')
            .trim();
        }
        // h1codeとラベルのマッピングを作成
        const labelToH1Map = {};
        Object.keys(casetype_selector).forEach(function(h1_code) {
          const label = casetype_selector[h1_code].label;
          labelToH1Map[label] = h1_code;
        });

        // 指定された順番で表示
        allowedCaseTypes.forEach(function(label) {
          const h1_code = labelToH1Map[label];
          if (!h1_code) return; // このラベルの商品が存在しない場合はスキップ
          
          const item = casetype_selector[h1_code];
          const displayLabel = normalizeCaseTypeDisplayLabel(item.label);
          const html = casetype_selector_template({
            handle: '/products/' + item.handle,
            image_url: item.image,
            price: item.price,
            active: item.active,
            description: displayLabel
          });
          $('.casetype-container').append(html);
        });
      } else {
        // ★スマホケース以外（バンドなど）は既存の処理
        Object.keys(casetype_selector).forEach(function(h1_code) {
          var item = casetype_selector[h1_code];
          var html = casetype_selector_template({
            handle: '/products/' + item.handle,
            image_url: item.image,
            price: item.price,
            active: item.active,
            description: item.label
          });
          $('.casetype-container').append(html);
        });
      }

      // 現在のタイプラベル
      var currentTypeLabel = '';
      Object.keys(casetype_selector).forEach(function(h1_code) {
        if (casetype_selector[h1_code].active) {
          currentTypeLabel = normalizeCaseTypeDisplayLabel(casetype_selector[h1_code].label);
        }
      });
      $('#js_casetype_name').text(currentTypeLabel);
    }
    // ----------------- カラー（共通） -----------------
    // ★プレミアムパネル系は「ケースのカラーを選ぶ」を常に非表示にし、
    //   代わりにマグネットリング選択（なし/ホワイト/ブラック）を使う
    if (isPanelMagnet(base_h1_code)) {
      $('.selector-container.is-casecolor').addClass('d-none');
    } else if (Object.keys(casecolor_links).length) {
      $('.selector-container.is-casecolor').removeClass('d-none');
      $('#js_casecolor_container').empty();

      // ケースカラー表示用に「リング部分の文言」を削るヘルパー
      function normalizeCaseColorLabel(colorTag) {
        var raw = colorTag.replace('cscl_', '');

        // 「半透明フレームwithホワイト」みたいな文言から
        // フレーム色だけを残す
        return raw
          .replace(/withホワイトリング/g, '')
          .replace(/withブラックリング/g, '')
          .replace(/＋ホワイトリング/g, '')
          .replace(/＋ブラックリング/g, '')
          .trim();
      }

      Object.keys(casecolor_links).forEach(function(colorTag) {
        var item = casecolor_links[colorTag];
        var label = normalizeCaseColorLabel(colorTag);

        var html = color_selector_template({
          handle: '/products/' + item.handle,
          color: label,
          active: item.active
        });
        $('#js_casecolor_container').append(html);
      });

      var currentColorLabel = '';
      Object.keys(casecolor_links).forEach(function(colorTag) {
        if (casecolor_links[colorTag].active) {
          currentColorLabel = normalizeCaseColorLabel(colorTag);
        }
      });
      $('#js_casecolor_label').text(currentColorLabel);
    }
  }
  // 機種名表示（for ◯◯）
  if (base_model_code) {
    var deleted_prefix = base_model_code.split('_')[1];
    var base_model_name = window.fox.settings.model[deleted_prefix];
    if (base_model_name) {
      $('.js-model').text('for ' + base_model_name);
    }
  }

  // 商品タイトルまわり
  var base_casetype_name_tag = tags.find(function(code) {
    return code.indexOf('h1_') === 0;
  });
  var base_itemtitle = tags.find(function(code) {
    return code.indexOf('productname_') === 0;
  });

  if (base_casetype_name_tag) {
    var casetypeName = window.fox.settings.h1[base_casetype_name_tag];
    // フレームミラー + 黒リングだけ別名
    if (base_h1_code === 'h1_FM' && base_case_color && base_case_color.indexOf('withブラック') !== -1) {
      casetypeName = window.fox.settings.h1['h1_FM_black_ring'];
    }
    if (casetypeName) {
      $('.js-product-title').html(casetypeName + '<br>'); // 一番上
    }
  }

  // コレクション名（col_◯◯）
  var base_collection_code2 = tags.find(function(code) {
    return code.indexOf('col_') === 0;
  });
  if (base_collection_code2) {
    var collection_name = base_collection_code2.replace('col_', '');
    $('.js-product-title').append(collection_name + '<br>');
  }

  // dsgn_◯◯
  var base_design_code = tags.find(function(code) {
    return code.indexOf('dsgn_') === 0;
  });
  if (base_design_code) {
    var design_name = base_design_code.replace('dsgn_', '');
    $('.js-product-title').append(design_name);
  }

  // FP用 ケース種別ラベル
  var fpCaseTypeNames = {
    m_PW: 'ホワイトフレーム',
    m_PB: 'ブラック付きフレーム',
    m_NW: 'クリアブラック＋ホワイト',
    m_NB: 'クリアブラック＋ブラック'
  };

  // model / casetype / color 用のマップ
  var model_links = {};
  var casetype_selector = {};
  var casetype_links = {};
  var casecolor_links = {};

  // ケースタイプの変数（スリング / リボン用）
  var base_casetype_color;
  var casetype_color;
  var casetypecolor_label_replace;
  var casetypecolor_text;

  var casetype_set = function(set_base_casetype_color, set_casetype_color, set_casetypecolor_label_replace, set_casetypecolor_text) {
    base_casetype_color = set_base_casetype_color;
    casetype_color = set_casetype_color;
    casetypecolor_label_replace = set_casetypecolor_label_replace;
    casetypecolor_text = set_casetypecolor_text;
  };

  // ------------------------------
  // ここからデザイン / ケース種別まわり
  // ------------------------------
  if (design_code) {
    // クエリをできるだけ絞る
    var queryParts = [
      'tag:\\"' + design_code + '\\"'
    ];

    if (base_model_code) {
      queryParts.push('tag:\\"' + base_model_code + '\\"');
    }
    if (base_index_no) {
      queryParts.push('tag:\\"' + base_index_no + '\\"');
    }

    // バンド系のときは h1_SC / h1_SL だけに限定（Apple Watch クリア/レザー）
    if (BAND_H1_LIST.indexOf(base_h1_code) > -1) {
      queryParts.push('(tag:\\"h1_SC\\" OR tag:\\"h1_SL\\")');
    }

    var designQuery = queryParts.join(' AND ');

    console.log('[GraphQL] designQuery =', designQuery);

    // ★ 1 回だけ GraphQL を呼ぶ（ページングなし）
    get_products_graphql(designQuery, function (data) {
      var products =
        data &&
        data.products &&
        Array.isArray(data.products.edges)
          ? data.products.edges
          : [];

      buildCaseSelectors(products);
    });
  }

if ($.fn && typeof $.fn.modaal === 'function') {
  $('.modaal').modaal();
} else {
  console.warn('[modaal] plugin not found -> skip');
}

  // 商品サムネイル slick
  $(function () {
    var $thumb = $('.js-product-thumbnails-container');
    if ($thumb.length && !$thumb.hasClass('slick-initialized')) {
      $thumb.slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 5,
        speed: 500,
        lazyLoad: 'progressive',
        prevArrow:'<button class="slick-arrow slick-prev"><svg><use xlink:href="#icon-slideshow-previous2"></use></svg></button>',
        nextArrow:'<button class="slick-arrow slick-next"><svg><use xlink:href="#icon-slideshow-next2"></use></svg></button>'
      });
    }
  });
  // note プロテクタースクリーンのついで買い関連の処理
  if (window.matchMedia('(max-width: 600px)').matches) {
    var buytogether_template_content = $('#js_buytogether-sp').html();
  } else {
    var buytogether_template_content = $('#js_buytogether').html();
  }
  console.log('[buytogether] base_h1_code=', base_h1_code, 'isCaseProduct=', isCaseProduct, 'isTB=', isTB, 'tagsLen=', tags.length);

  if (!window._ || typeof _.template !== 'function') {
    console.warn('[buytogether] underscore template not found -> skip rendering');
    buytogether_template = null;
  } else {
    buytogether_template = _.template(buytogether_template_content);
  }
  var buyTogetherAccessoryList =
    (window.fox && window.fox.settings && window.fox.settings.buyTogetherAccessoryList) || [];
  window.buyTogetherAccessoryList = buyTogetherAccessoryList;


  var getOfBuyTogetherAccessory = function(query , callback ) {
    $.ajax({
      type: 'POST',
      timeout: 8000,
      url: '/api/2019-07/graphql.json',
      headers: {
        'Content-Type': 'application/graphql',
        'X-Shopify-Storefront-Access-Token': ACCESS_TOKEN_STORE_FRONT_API
      },
      data: '{ products(query: "' + query + '", first: 250) { edges { cursor, node { id, handle, title, tags, publishedAt, productType, priceRange { minVariantPrice { amount } }, variants(first: 1) { edges { node { id, availableForSale } } }, images(first:1) { edges { node { originalSrc } } } } }, pageInfo { hasNextPage } } }',
      cache: false
    }).done(function(resp) {
      $(window).on('load', function() {
        //spチェック時のカラーを選択
        var accessory_choice_add = {
          color:"#FFF",
          background:"#f85b58"
        }
        var accessory_choice_remove = {
          color:"#000",
          background:"#FFF"
        }
        if (window.matchMedia('(max-width: 600px)').matches) {
          $('.js-ly-product-add .mod-checkbox-sp').addClass('d-none');
          var label_num = $('.is-buytogether-sp label').length;
          if (label_num <= 2) {
            $('.is-buytogether-sp').css('padding-left','20px');
          }
        } else {
          $('.js-ly-product-add .buytogether-wrapper').addClass('d-none');
        }
        //チェックつけた商品のポップアップに表示されている、アクセサリー項目を表示(pc)
        $('.mod-checkbox').change(function() {
          var accessoryclassName = $(this).parents(".buytogether-wrapper").attr("class");
          if (accessoryclassName) {
          var cartaddcheck_num = accessoryclassName.replace(/[^0-9]/g, '');
          }
          if ($(this).children("input[name=buytogether]").is(':checked')) {
            $('.js-ly-product-add .accessory'+cartaddcheck_num+'').removeClass('d-none');
          } else {
            $('.js-ly-product-add .accessory'+cartaddcheck_num+'').addClass('d-none');
          }
        });
        //(sp)
        $('.mod-checkbox-sp').change(function() {
          var accessoryclassName = $(this).attr("class");
          if (accessoryclassName) {
          var cartaddcheck_num = accessoryclassName.replace(/[^0-9]/g, '');
          }
          if ($(this).children("input[name=buytogether]").is(':checked')) {
            $(this).find('.buytogether-price-sp,.buytogether-introduction, .js-buytogether-model').css(accessory_choice_add);
            $(this).find('.buytogether-introduction .name').css('color',"#FFF");
            $('.js-ly-product-add .accessory'+cartaddcheck_num+'').removeClass('d-none');
          } else {
            //チェック外したら色を戻す
            $(this).find('.buytogether-price-sp, .buytogether-introduction, .js-buytogether-model').css(accessory_choice_remove);
            $(this).find('.buytogether-price-sp').css('color',"#f85b58");
            $(this).find('.buytogether-introduction .name').css('color',"#000");
            $('.js-ly-product-add .accessory'+cartaddcheck_num+'').addClass('d-none');
          }
        });
      });

      var edges = resp.data.products.edges;
      return callback(edges);
    }).fail(function(e) {
      return console.error(e);
    })
  };

  var queryGetOfBuyTogetherAccessory = function (accessoryTag, searchParameter) {
    if (searchParameter == ACCESSORY_QUERY_MODEL) {
      return 'tag:\\"' + accessoryTag + '\\" AND tag:\\"' + base_model_code + '\\"';
    } else if(searchParameter == ACCESSORY_QUERY_DESIGN) {
      return 'tag:\\"' + accessoryTag + '\\" AND tag:\\"' + design_code + '\\" AND tag:\\"' + base_index_no + '\\"';
    } else {
      return 'tag:\\"' + accessoryTag + '\\"';
    }
  };
  if ( isCaseProduct || isTB ) {
    for (let i = 0; i < buyTogetherAccessoryList.length; ++i) {
      getOfBuyTogetherAccessory(
        queryGetOfBuyTogetherAccessory(buyTogetherAccessoryList[i].tag, buyTogetherAccessoryList[i].query),
        function (edges) {
          if (edges.length > 0) {
            var model_code = 'for ' + base_model_name;
            var productClassName = 'accessory'+[i]+'';
            var productAvailableForSale = edges[0].node.variants.edges[0].node.availableForSale;
            var productId = edges[0].node.variants.edges[0].node.id;
            try {
              if (productId.startsWith('Z2lk') || productId.includes('gid://')) {
                productId = atob(productId).split('/').pop();
              }
            } catch (e) {
              console.warn('productId not Base64 or failed to decode:', productId);
            }
            var productName = edges[0].node.title;
            var productUrl = edges[0].node.handle;
            var productPrice = edges[0].node.priceRange.minVariantPrice.amount;
            productPrice = Math.round(productPrice).toLocaleString();
            var productImageUrl = edges[0].node.images.edges[0].node.originalSrc;
            var cut = "for";
            var pos = productName.split(cut);

            var productIsProtectionGlass = function(){
              if( buyTogetherAccessoryList[i].tag == 'h1_PG' ){
                return true;
              } else {
                return false;
              }
            }
            if (productIsProtectionGlass()) {
              productName = '【画面割れ補償付き】' + productName;
            }
            function textTrim(text, count) {
              if (text.length > count) {
                var showText = text.substring(0, count);
                showText += '…';
                return showText;
              } else {
                return text;
              }
            }
            if (productAvailableForSale) {
              $('#js_buytogether_container').removeClass('d-none');
              var buytogether_html = buytogether_template({'productClassName': productClassName ,'model_code': model_code, 'sortNum': i, 'productUrl': productUrl, 'productName': productName, 'productId': productId, 'productImageUrl': productImageUrl, 'productPrice': productPrice, 'productIsProtectionGlass': productIsProtectionGlass() });
              if (window.matchMedia('(max-width: 600px)').matches) {
                productNameCut = productName.replace('【画面割れ補償付き】','');
                productNameCut = (pos[0]+cut).replace('for','');
                productNameCut = textTrim(productNameCut, 11);
                var buytogether_html_productNameCut = buytogether_template({'productClassName': productClassName ,'model_code': model_code, 'sortNum': i, 'productUrl': productUrl, 'productName': productNameCut, 'productId': productId, 'productImageUrl': productImageUrl, 'productPrice': productPrice, 'productIsProtectionGlass': productIsProtectionGlass() });
                $('.is-buytogether-sp').append(buytogether_html_productNameCut);
                $('.product-add-buytogether-sp').append(buytogether_html);
              } else {
                $('.is-buytogether').append(buytogether_html);
              }
            }
          }
        }
      )
    }
  }


  // note ケース以外の商品詳細画面の場合は、『素材で選ぶ』『アクセサリを追加』『Similar Design Case』 を消す
  // h1_BC はケース商品扱いにはしないが、ケースタイプ・ケースカラー選択だけは表示する
  if (!isCaseProduct) {
    if (!isCaseSelectorProduct) {
      $('.selector-container.is-casetype').addClass('d-none');
    }

    $('.similar-design-container').addClass('d-none');
    if (!isTB) {
      $('.buytogether-container').addClass('d-none');
    } else {
      $('.buytogether-container').removeClass('d-none');
    }
  }

  // note 形状素材についてのモーダルの中身を出し分ける
  if (isCaseProduct) {
    $('.js-material-case-content').removeClass('d-none');
  } else {
    $('.js-material-protection-glass-content').removeClass('d-none');
  }


  // buytogether-checkboxを選択したらカートに追加しましたテンプレートに商品を追加、削除する
  var buytogetherAddCartProducts = [];

  $('.buytogether-checkbox').change(function() {
    if ($(this).is(':checked')) {
      var details = {
        title: $(this).closest('.inner').find('.title').text(),
        price: $(this).closest('.inner').find('.price').html(),
        image: $(this).closest('.inner').find('img').attr('src'),
      }
      buytogetherAddCartProducts.push(details);
    } else {
      buytogetherAddCartProducts = buytogetherAddCartProducts.filter(function(item) {
        return item !== $(this).val();
      });
    }
    console.log(buytogetherAddCartProducts);
    $('.is-buytogether').html('');
    buytogetherAddCartProducts.forEach(function(item) {
      var price = item.price.replace(/（税込）/g, '');

      var html = `
      <div class="inner product-add-case">
        <div class="image-container">
          <img src="${item.image}" alt="${item.title}" width="60">
        </div>
        <div class="introductions-header">
          <p class="title">${item.title}</p>
          <div class="product-price">
            <strong>${price}</strong>
            <span class="unit">（税込）</span>
          </div>
        </div>
      </div>
      `;
      $('.is-buytogether').append(html);
    });
  });


});
// =======================================================
// GraphQL（global wrapper）
// ※ ready内の get_products_graphql を外から使いたいので公開する
// =======================================================
window.get_products_graphql = window.get_products_graphql || function (query, callback, cursor) {
  // 既存コードと同じ前提：theme_accessToken が global にある
  var ACCESS_TOKEN_STORE_FRONT_API = theme_accessToken;

  var cursor_query = '';
  if (cursor) cursor_query = ', after: "' + cursor + '"';

  return $.ajax({
    type: 'POST',
    timeout: 8000,
    url: '/api/2024-07/graphql.json',
    headers: {
      'Content-Type': 'application/graphql',
      'X-Shopify-Storefront-Access-Token': ACCESS_TOKEN_STORE_FRONT_API
    },
    data:
      '{ products(query: "' + query + '", first: 250' + cursor_query + ') {' +
        ' edges { cursor, node { ' +
          ' title, id, handle, tags,' +
          ' priceRange { minVariantPrice { amount } },' +
          ' publishedAt, productType,' +
          ' images(first:1) { edges { node { originalSrc } } }' +
        ' } },' +
        ' pageInfo { hasNextPage }' +
      ' } }',
    cache: false
  }).done(function (e) {
    callback(e.data);
  }).fail(function (e) {
    console.error(e);
    callback(null);
  });
};

// theme.jsで読み込ませるためglobal関数にする
window.buyTogetherAddCart = function buyTogetherAddCart() {
  try {
    var ids = [];
    $('[class="buytogether-checkbox"]:checked').each(function () {
      var v = Number($(this).val());
      if (!Number.isNaN(v) && v > 0) ids.push(v);
    });

    // 何も選ばれてなければ何もしない
    if (!ids.length) return;

    // ★未定義でも落ちない（window経由）
    var list = Array.isArray(window.buyTogetherAccessoryList) ? window.buyTogetherAccessoryList : [];
    console.log('[buytogether] selected=', ids.length, 'masterList=', list.length);

    var data = { items: [] };
    for (var i = 0; i < ids.length; i++) {
      data.items.push({ quantity: 1, id: ids[i] });
    }

    return $.ajax({
      url: '/cart/add.js',
      type: 'post',
      dataType: 'json',
      data: data
    });
  } catch (e) {
    console.error('[buyTogetherAddCart] failed', e);
  }
};


// 機種選択とメーカーの条件分岐を初期化する関数
// 機種選択とメーカーの条件分岐を初期化する関数
function setupModelFiltering() {
  const tags = getTagsSafe();
  if (!tags.length) return;

  const baseH1 = tags.find(t => t.startsWith('h1_'));
  if (!baseH1) return;

  const seriesSelector = document.querySelector('.series');
  const modelSelector  = document.querySelector('.model_selector.models');
  const modelWrapper   = document.querySelector('.selector-container.is-model');
  const shouldHideModel = MODEL_HIDDEN_H1_LIST.includes(baseH1);

  if (shouldHideModel) {
    if (modelWrapper) modelWrapper.classList.add('d-none');

    if (seriesSelector) {
      $(seriesSelector).off('.modelFiltering .we');
      seriesSelector.disabled = true;
      seriesSelector.style.display = 'none';
    }

    if (modelSelector) {
      $(modelSelector).off('.modelNavigate');
      modelSelector.disabled = true;
      modelSelector.style.display = 'none';
      modelSelector.innerHTML = '';
    }

    console.log('[modelFiltering] skip/hide:', baseH1);
    return;
  }

  if (!seriesSelector || !modelSelector) {
    console.warn('[modelFiltering] selector not found');
    return;
  }

  if (modelWrapper) {
    modelWrapper.classList.remove('d-none');
  }

  const h2Tag    = tags.find(t => t.startsWith('h2_'));
  const indexTag = tags.find(t => t.startsWith('index_'));

  if (!h2Tag || !indexTag) {
    console.warn('[modelFiltering] missing h2_/index_', { h2Tag, indexTag });
    return;
  }

  const isSPCC = isSpCc(baseH1);

  // h1_FS / h1_FP / h1_MS は、機種切り替え上は同一グループとして扱う
  // 例：h1_FSの商品ページでも、メーカー変更時に h1_FP / h1_MS 側の商品が候補にあれば拾えるようにする
  const MAGNET_MODEL_GROUP = ['h1_FS', 'h1_FP', 'h1_MS'];
  const isMagnetModelGroup = MAGNET_MODEL_GROUP.includes(baseH1);

  // ★プレミアムパネル（リング付き）も同様に、メーカー変更で h1_PP / h1_PM を横断できるようにする
  //   （リングなし h1_PN は従来どおり自身のh1のみで機種を引く＝スクエアの h1_FN と同じ扱い）
  const PANEL_MAGNET_MODEL_GROUP = ['h1_PP', 'h1_PM'];
  const isPanelMagnetModelGroup = PANEL_MAGNET_MODEL_GROUP.includes(baseH1);

  // ★機種変更時に「フレームカラー・リングカラー」も維持するための基準値
  const baseCsclTag = tags.find(t => t.startsWith('cscl_'));
  const baseMTag    = tags.find(t => t.startsWith('m_'));
  const baseNormalizedFrame = baseCsclTag ? normalizeCaseColorTag(baseCsclTag) : null;

  // ラベル依存判定だけだと FR が漏れることがあるので補強
  const phoneCaseH1List = getPhoneCaseH1List();
  const forcePhoneCaseH1 = [
    'h1_FR',
    'h1_FM',
    'h1_FC',
    'h1_FP',
    'h1_FS',
    'h1_FN',
    'h1_MS',
    'h1_SP',
    'h1_CC',
    'h1_PN',
    'h1_PP',
    'h1_PM'
  ];

  const isPhoneCaseProduct =
    phoneCaseH1List.includes(baseH1) || forcePhoneCaseH1.includes(baseH1);

  if (!isPhoneCaseProduct) {
    console.log('[modelFiltering] skip non phone-case h1=', baseH1);
    return;
  }

  // バンド/AW系は既存の別処理に任せる
  if (
    BAND_H1_LIST.includes(baseH1) ||
    baseH1 === 'h1_AWCB' ||
    baseH1 === 'h1_AWLB'
  ) {
    console.log('[modelFiltering] skip band/AW h1=', baseH1);
    return;
  }

  // 初期化
  modelSelector.innerHTML = '<option value="" disabled selected>機種を選択してください</option>';
  modelSelector.style.display = 'none';

  // 既存イベントを解除
  $(seriesSelector).off('.modelFiltering');

  // SP/CC は両方対象
  // h1_FS / h1_FP / h1_MS は同一グループとして対象
  // h1_PP / h1_PM（パネルのリング付き）も同一グループとして対象
  // それ以外は現在のh1のみ対象
  const query = isSPCC
    ? [
        'tag:\\"' + h2Tag + '\\"',
        'tag:\\"' + indexTag + '\\"',
        '(tag:\\"h1_SP\\" OR tag:\\"h1_CC\\")'
      ].join(' AND ')
    : isMagnetModelGroup
      ? [
          'tag:\\"' + h2Tag + '\\"',
          'tag:\\"' + indexTag + '\\"',
          '(tag:\\"h1_FS\\" OR tag:\\"h1_FP\\" OR tag:\\"h1_MS\\")'
        ].join(' AND ')
      : isPanelMagnetModelGroup
        ? [
            'tag:\\"' + h2Tag + '\\"',
            'tag:\\"' + indexTag + '\\"',
            '(tag:\\"h1_PP\\" OR tag:\\"h1_PM\\")'
          ].join(' AND ')
        : [
            'tag:\\"' + h2Tag + '\\"',
            'tag:\\"' + indexTag + '\\"',
            'tag:\\"' + baseH1 + '\\"'
          ].join(' AND ');

  console.log('[modelFiltering] query=', query);

  window.get_products_graphql(query, function (data) {
    const edges = (data && data.products && Array.isArray(data.products.edges))
      ? data.products.edges
      : [];

    if (!edges.length) {
      console.warn('[modelFiltering] no products found');
      return;
    }

    // ブランド別の実在商品マップを作る
    // byBrand = {
    //   AP: {
    //     AP2221: { handle: 'handle-a', h1Tag: 'h1_FS' }
    //   },
    //   SS: {
    //     SS2374: { handle: 'handle-b', h1Tag: 'h1_FP' }
    //   }
    // }
    const byBrand = {};

    edges.forEach(edge => {
      const node = edge.node || {};
      const ptags = node.tags || [];
      const handle = node.handle;

      if (!handle) return;

      const moTag = ptags.find(t => t.startsWith('mo_'));
      if (!moTag) return;

      const h1Tag = ptags.find(t => t.startsWith('h1_'));
      if (!h1Tag) return;

      const modelCode = moTag.replace('mo_', '').toUpperCase();
      const brandCode = modelCode.slice(0, 2);

      if (!brandCode) return;

      if (!byBrand[brandCode]) byBrand[brandCode] = {};

      // 現在の商品との一致度をスコア化して代表商品を選ぶ
      // フレームカラー(+4) > リングカラー(+2) > マウントタイプ(+1) の優先度
      // → 機種を変えても「フレームカラー・リングカラー・マウントタイプ」を維持する
      const nodeCscl = ptags.find(t => t.startsWith('cscl_'));
      const nodeM    = ptags.find(t => t.startsWith('m_'));

      let matchScore = 0;
      if (baseNormalizedFrame && nodeCscl &&
          normalizeCaseColorTag(nodeCscl) === baseNormalizedFrame) {
        matchScore += 4;
      }
      if (baseMTag && nodeM && nodeM === baseMTag) {
        matchScore += 2;
      }
      if (h1Tag === baseH1) {
        matchScore += 1;
      }

      const currentItem = byBrand[brandCode][modelCode];
      if (!currentItem || matchScore > (currentItem._score || -1)) {
        byBrand[brandCode][modelCode] = {
          handle: handle,
          h1Tag: h1Tag,
          _score: matchScore
        };
      }
    });

    console.log('[modelFiltering] byBrand=', byBrand);

    // メーカー選択時に機種を描画
    $(seriesSelector).on('change.modelFiltering', function () {
      const selectedBrandCode = String(this.value || '').toUpperCase();
      const modelGroups = (window.fox.settings && window.fox.settings.model_groups) || [];
      const modelGroup = modelGroups.find(g => String(g.code).toUpperCase() === selectedBrandCode);

      modelSelector.innerHTML = '<option value="" disabled selected>機種を選択してください</option>';

      const existMap = byBrand[selectedBrandCode] || {};
      const existCodes = Object.keys(existMap);

      if (!existCodes.length) {
        console.warn('[modelFiltering] no models for brand=', selectedBrandCode);
        modelSelector.style.display = 'none';
        return;
      }

      const optgroup = document.createElement('optgroup');
      const selectedLabel = this.options[this.selectedIndex]
        ? this.options[this.selectedIndex].text
        : selectedBrandCode;

      optgroup.label = selectedLabel;

      // model_groups の順を優先
      const orderedCodes = [];

      if (modelGroup && Array.isArray(modelGroup.code_sort)) {
        modelGroup.code_sort.forEach(code => {
          const upper = String(code).toUpperCase();

          if (existMap[upper]) {
            orderedCodes.push(upper);
          }
        });
      }

      // code_sort にないものも末尾に補完
      existCodes.forEach(code => {
        if (!orderedCodes.includes(code)) {
          orderedCodes.push(code);
        }
      });

      orderedCodes.forEach(code => {
        const item = existMap[code];
        const handle = item && item.handle;
        if (!handle) return;

        const modelName =
          window.fox.settings.model[code] ||
          window.fox.settings.model[code.toLowerCase()] ||
          code;

        const option = document.createElement('option');

        option.value = `/products/${handle}`;
        option.textContent = modelName;
        option.setAttribute('data-model', code);

        optgroup.appendChild(option);
      });

      modelSelector.appendChild(optgroup);
      modelSelector.style.display = 'block';

      console.log('[modelFiltering] options built:', selectedBrandCode, orderedCodes.length);
    });

    // 現在の商品ブランドが分かるなら、初期状態でそのメーカーを選択しておく
    const baseMoTag = tags.find(t => t.startsWith('mo_'));

    if (baseMoTag) {
      const baseModelCode = baseMoTag.replace('mo_', '').toUpperCase();
      const baseBrandCode = baseModelCode.slice(0, 2);

      if (baseBrandCode) {
        seriesSelector.value = baseBrandCode;
        $(seriesSelector).trigger('change.modelFiltering');
      }
    }
  });
}
// -------------------------------------------------------
// 機種セレクトの value から商品ページへ遷移する共通関数
// ・value がフルURL        → そのまま遷移
// ・value が /products/... → そのまま遷移
// ・それ以外（handle）     → /products/{handle} に遷移
// -------------------------------------------------------
function navigateProductByValue(raw) {
  if (!raw) return;
  var val = String(raw).trim();
  if (!val) return;

  // フル URL（レンズガラスなど）
  if (/^https?:\/\//.test(val)) {
    window.location.href = val;
    return;
  }

  // すでに /products/ から始まっている（今回のスマホケース新ロジック）
  if (val.indexOf('/products/') === 0) {
    window.location.href = val;
    return;
  }

  // それ以外は handle とみなして /products/ を付与
  val = val.replace(/^\/+/, ''); // 先頭の / を削る保険
  window.location.href = '/products/' + val;
}
// =======================================================
// WE（ワイヤレスイヤホンケース）専用：メーカー→機種
// 条件: h1_WE かつ m_WU
// handle: we_wu_cl{baseCode}-{index}_{moLower}
// =======================================================
document.addEventListener('DOMContentLoaded', function () {
  const tags = getTagsSafe();
  if (!tags.length) return;
  if (!tags.length) return;

  const baseH1 = tags.find(t => t.startsWith('h1_'));
  const isWE = (baseH1 === 'h1_WE') && tags.includes('m_WU');
  if (!isWE) return;

  const seriesSelector = document.querySelector('.series');
  const modelSelector  = document.querySelector('.model_selector.models');
  if (!seriesSelector || !modelSelector) return;

  // UIは必ず出す
  const modelWrapper = document.querySelector('.selector-container.is-model');
  if (modelWrapper) modelWrapper.classList.remove('d-none');

  // h2/index は “同一デザイン群” を取るキー
  const h2Tag       = tags.find(t => t.startsWith('h2_'));
  const indexTag    = tags.find(t => t.startsWith('index_'));
  const baseCode    = h2Tag ? h2Tag.replace('h2_', '').replace(/^cl/i, '').toLowerCase() : null;
  const indexNumber = indexTag ? indexTag.replace('index_', '') : '11';

  if (!h2Tag || !indexTag || !baseCode) {
    console.warn('[WE] missing h2_/index_ tag', { h2Tag, indexTag, baseCode });
    return;
  }

  // ★重要：moで絞らない（同一デザインの別機種が取れなくなる）
  const query = [
    'tag:\\"h1_WE\\"',
    'tag:\\"m_WU\\"',
    'tag:\\"' + h2Tag + '\\"',
    'tag:\\"' + indexTag + '\\"'
  ].join(' AND ');

  console.log('[WE GraphQL] query =', query);

  // 既存の選択肢をクリア
  seriesSelector.innerHTML = '<option value="" disabled selected>メーカーを選択</option>';
  modelSelector.style.display = 'none';
  modelSelector.innerHTML = '';

  // 既存イベントの衝突を避ける（WEだけ）
  $('.series').off('change.we');
  // modelSelectorのchangeは共通delegateがあるのでWE側では付けない

  // GraphQL取得
  if (!window.get_products_graphql) {
    console.error('[WE] window.get_products_graphql is not available');
    return;
  }

  window.get_products_graphql(query, function (data) {
    const edges = (data && data.products && Array.isArray(data.products.edges)) ? data.products.edges : [];
    if (!edges.length) {
      console.warn('[WE] no products found for query', query);
      return;
    }

    // mo_ からメーカー分類
    const groups = { AP: [], SS: [] };

    edges.forEach(e => {
      const node = e.node || {};
      const ptags = node.tags || [];
      const handle = node.handle;
      if (!handle) return;

      const moTag = ptags.find(t => t.startsWith('mo_'));
      if (!moTag) return;

      const moCode = moTag.replace('mo_', ''); // AP2157 / SS2374 etc
      const brand = moCode.startsWith('AP') ? 'AP' : (moCode.startsWith('SS') ? 'SS' : null);
      if (!brand) return;

      // handle規則に合うものだけ（誤混入防止）
      const expectPrefix = `we_wu_cl${baseCode}-${indexNumber}_`;
      const expectSuffix = `_${moCode.toLowerCase()}`;
      if (!(handle.indexOf(expectPrefix) === 0 && handle.endsWith(expectSuffix))) return;

      groups[brand].push({ moCode, handle });
    });

    // メーカー候補
    const brands = [];
    if (groups.AP.length) brands.push({ code: 'AP', name: 'Apple' });
    if (groups.SS.length) brands.push({ code: 'SS', name: 'Samsung' });

    // メーカーが空なら何もしない
    if (!brands.length) {
      console.warn('[WE] no brand groups', groups);
      return;
    }

    // メーカー選択肢
    brands.forEach(b => {
      const opt = document.createElement('option');
      opt.value = b.code;
      opt.textContent = b.name;
      seriesSelector.appendChild(opt);
    });

    // 表示名は settings.model を優先、なければ moCode
    const getModelName = (moCode) => {
      const dict = (window.fox && window.fox.settings && window.fox.settings.model) || {};
      return dict[moCode] || dict[moCode.toUpperCase()] || moCode;
    };

    const getModelDictKeys = () => {
      const dict = (window.fox && window.fox.settings && window.fox.settings.model) || {};
      return Object.keys(dict);
    };

    const orderByModelDict = (brand, list) => {
      const dictKeys = getModelDictKeys();
      const exists = new Map(list.map(x => [String(x.moCode).toUpperCase(), x]));

      // 辞書順に存在するものだけ拾う
      const ordered = [];
      dictKeys.forEach(k => {
        const key = String(k).toUpperCase();
        if (!key.startsWith(brand)) return;
        const item = exists.get(key);
        if (item) ordered.push(item);
      });

      list.forEach(x => {
        if (!ordered.includes(x)) ordered.push(x);
      });

      return ordered;
    };

    // メーカー選択時：機種option作成
    $('.series').on('change.we', function () {
      const brand = this.value;
      const list = (groups[brand] || []).slice();

      modelSelector.innerHTML = '<option value="" disabled selected>機種を選択してください</option>';

      // 表示順を安定させる（moCode順）
      const orderedList = orderByModelDict(brand, list);

      const og = document.createElement('optgroup');
      og.label = (brand === 'AP') ? 'Apple' : 'Samsung';

      orderedList.forEach(item => {
        const opt = document.createElement('option');
        opt.value = `/products/${item.handle}`;  // ★共通navigateに乗せる
        opt.textContent = getModelName(item.moCode);
        og.appendChild(opt);
      });

      modelSelector.appendChild(og);
      modelSelector.style.display = 'block';
    });

    console.log('[WE] init done', { ap: groups.AP.length, ss: groups.SS.length });
  });
});

//イヤホンケース Apple Watchクリアバンド Apple Watchレザーバンド レンズガラスの機種を選ぶコード
document.addEventListener('DOMContentLoaded', function () {
  const productTags = getTagsSafe();
  if (!productTags.length) return;
  if (productTags.includes('h1_WE')) return;
  const seriesSelector = document.querySelector('.series');
  const modelSelector = document.querySelector('.model_selector.models');

  if (!seriesSelector || !modelSelector) return;

  // クリアバンド（ケースタイプ）：m_cs / m_ck
  const hasClearSubtype = productTags.some(tag =>
    tag === 'm_cs' || tag === 'm_ck'
  );

  // レザーバンド（ケースタイプ）：m_ws / m_wk
  const hasLeatherSubtype = productTags.some(tag =>
    tag === 'm_ws' || tag === 'm_wk'
  );

  const baseH2Tag = productTags.find(tag => tag.startsWith('h2_'));
  const baseCode = baseH2Tag ? baseH2Tag.replace('h2_', '').replace(/^cl/i, '').toLowerCase() : null;
  const indexTag = productTags.find(tag => tag.startsWith('index_'));
  const indexNumber = indexTag ? indexTag.replace('index_', '') : '11';

  const currentH1Tag = productTags.find(tag => [
    'h1_AP', 'h1_GBP', 'h1_GB2P', 'h1_GB2', 'h1_AWCB', 'h1_AWLB','h1_SC', 'h1_SL'
  ].includes(tag));

  const config = {
    'earphone': {
      tags: ['h1_AP', 'h1_GBP', 'h1_GB2P', 'h1_GB2'],
      brands: ['AP', 'SS'],
      models: {
        AP: [
          { name: 'AirPods Pro', suffix: 'ap2157' },
          { name: 'AirPods（第2世代）', suffix: 'ap2155' },
          { name: 'AirPods（第1世代）', suffix: 'ap2154' }
        ],
        SS: [
          { name: 'Galaxy Buds2', prefix: 'gb2_pc_' },
          { name: 'Galaxy Buds2 Pro', prefix: 'gb2p_gb2p_' },
          { name: 'Galaxy Buds Pro', prefix: 'gbp_gbp_' }
        ]
      }
    },
    'clearband': {
      tags: ['h1_SC'],
      apHandleBase: 'sc_awcbtpu_',
      brands: ['AP', 'SS', 'GM'],
      models: {
        AP: [
          { name: 'Apple Watch Series 11 (42mm)', suffix: 'ap2331' },
          { name: 'Apple Watch Series 11 (46mm)', suffix: 'ap2332' },
          { name: 'Apple Watch Series 10 (42mm)', suffix: 'ap2329' },
          { name: 'Apple Watch Series 10 (46mm)', suffix: 'ap2330' },
          { name: 'Apple Watch Series 9 (41mm)', suffix: 'ap2323' },
          { name: 'Apple Watch Series 9 (45mm)', suffix: 'ap2324' },
          { name: 'Apple Watch Series 8 (41mm)', suffix: 'ap2318' },
          { name: 'Apple Watch Series 8 (45mm)', suffix: 'ap2319' },
          { name: 'Apple Watch Series 7 (41mm)', suffix: 'ap2316' },
          { name: 'Apple Watch Series 7 (45mm)', suffix: 'ap2317' },
          { name: 'Apple Watch Series 6 (40mm)', suffix: 'ap2312' },
          { name: 'Apple Watch Series 6 (44mm)', suffix: 'ap2313' },
          { name: 'Apple Watch Series 5 (40mm)', suffix: 'ap2310' },
          { name: 'Apple Watch Series 5 (44mm)', suffix: 'ap2311' },
          { name: 'Apple Watch Series 4 (40mm)', suffix: 'ap2308' },
          { name: 'Apple Watch Series 4 (44mm)', suffix: 'ap2309' },
          { name: 'Apple Watch Series 3 (38mm)', suffix: 'ap2306' },
          { name: 'Apple Watch Series 3 (42mm)', suffix: 'ap2307' },
          { name: 'Apple Watch Series 2 (38mm)', suffix: 'ap2304' },
          { name: 'Apple Watch Series 2 (42mm)', suffix: 'ap2305' },
          { name: 'Apple Watch Series 1 (38mm)', suffix: 'ap2302' },
          { name: 'Apple Watch Series 1 (42mm)', suffix: 'ap2303' },
          { name: 'Apple Watch Series 0 (38mm)', suffix: 'ap2300' },
          { name: 'Apple Watch Series 0 (42mm)', suffix: 'ap2301' },
          { name: 'Apple Watch Series SE（第3世代）	 (40mm)', suffix: 'ap2327' },
          { name: 'Apple Watch Series SE（第3世代）	 (44mm)', suffix: 'ap2328' },
          { name: 'Apple Watch Series SE（第2世代）	 (40mm)', suffix: 'ap2320' },
          { name: 'Apple Watch Series SE（第2世代）	 (44mm)', suffix: 'ap2321' },
          { name: 'Apple Watch Series SE（第1世代） (40mm)', suffix: 'ap2314' },
          { name: 'Apple Watch Series SE（第1世代） (44mm)', suffix: 'ap2315' },
          { name: 'Apple Watch Ultra 3 (49mm)', suffix: 'ap2326' },
          { name: 'Apple Watch Ultra 2 (49mm)', suffix: 'ap2325' },
          { name: 'Apple Watch Ultra (49mm)', suffix: 'ap2322' }
        ],
        SS: [
          { name: 'Galaxy Watch 8 (40 mm)', prefix: 'ss2388' },
          { name: 'Galaxy Watch 8 (44 mm)', prefix: 'ss2389' },
          { name: 'Galaxy Watch 8 Classic', prefix: 'ss2390' },
          { name: 'Galaxy Watch 7 (40 mm)', prefix: 'ss2309' },
          { name: 'Galaxy Watch 7 (44 mm)', prefix: 'ss2310' },
          { name: 'Galaxy Watch 6 (40 mm)', prefix: 'ss2305' },
          { name: 'Galaxy Watch 6 (44 mm)', prefix: 'ss2306' },
          { name: 'Galaxy Watch 6 Classic (43mm)', prefix: 'ss2307' },
          { name: 'Galaxy Watch 6 Classic (47mm)', prefix: 'ss2308' },
          { name: 'Galaxy Watch 5 (40 mm)', prefix: 'ss2303' },
          { name: 'Galaxy Watch 5 (44 mm)', prefix: 'ss2304' },
          { name: 'Galaxy Watch 5 Pro (45mm)', prefix: 'ss2302' },
          { name: 'Galaxy Watch FE (40mm)', prefix: 'ss2311' },
          { name: 'Galaxy Watch Ultra (47mm)', prefix: 'ss2312' }
        ],
        GM: [
          { name: 'Fenix 8シリーズ（43mm）', prefix: 'gm2311' },
          { name: 'Fenix 8シリーズ（47mm）', prefix: 'gm2312' },
          { name: 'Fenix 8シリーズ（51mm）', prefix: 'gm2313' },
          { name: 'Fenix 7シリーズ（42mm）', prefix: 'gm2308' },
          { name: 'Fenix 7シリーズ（47mm）', prefix: 'gm2309' },
          { name: 'Fenix 7シリーズ（51mm）', prefix: 'gm2310' },
          { name: 'vivoactive 6（42.2mm）', prefix: 'gm2314' },
          { name: 'Forerunner 570（42mm）', prefix: 'gm2315' },
          { name: 'Forerunner 570（47mm）', prefix: 'gm2316' },
          { name: 'Forerunner 165（43mm）', prefix: 'gm2307' },
          { name: 'Forerunner 265 (46.1mm)', prefix: 'gm2305' },
          { name: 'Forerunner 965 (47.2mm)', prefix: 'gm2306' }
        ]
      }
    },
    'leatherband': {
      tags: ['h1_SL'],
      apHandleBase: 'sl_awlbvl_',
      brands: ['AP', 'SS', 'GM'],
      models: {
        AP: [
          { name: 'Apple Watch Series 11 (42mm)', suffix: 'ap2331' },
          { name: 'Apple Watch Series 11 (46mm)', suffix: 'ap2332' },
          { name: 'Apple Watch Series 10 (42mm)', suffix: 'ap2329' },
          { name: 'Apple Watch Series 10 (46mm)', suffix: 'ap2330' },
          { name: 'Apple Watch Series 9 (41mm)', suffix: 'ap2323' },
          { name: 'Apple Watch Series 9 (45mm)', suffix: 'ap2324' },
          { name: 'Apple Watch Series 8 (41mm)', suffix: 'ap2318' },
          { name: 'Apple Watch Series 8 (45mm)', suffix: 'ap2319' },
          { name: 'Apple Watch Series 7 (41mm)', suffix: 'ap2316' },
          { name: 'Apple Watch Series 7 (45mm)', suffix: 'ap2317' },
          { name: 'Apple Watch Series 6 (40mm)', suffix: 'ap2312' },
          { name: 'Apple Watch Series 6 (44mm)', suffix: 'ap2313' },
          { name: 'Apple Watch Series 5 (40mm)', suffix: 'ap2310' },
          { name: 'Apple Watch Series 5 (44mm)', suffix: 'ap2311' },
          { name: 'Apple Watch Series 4 (40mm)', suffix: 'ap2308' },
          { name: 'Apple Watch Series 4 (44mm)', suffix: 'ap2309' },
          { name: 'Apple Watch Series 3 (38mm)', suffix: 'ap2306' },
          { name: 'Apple Watch Series 3 (42mm)', suffix: 'ap2307' },
          { name: 'Apple Watch Series 2 (38mm)', suffix: 'ap2304' },
          { name: 'Apple Watch Series 2 (42mm)', suffix: 'ap2305' },
          { name: 'Apple Watch Series 1 (38mm)', suffix: 'ap2302' },
          { name: 'Apple Watch Series 1 (42mm)', suffix: 'ap2303' },
          { name: 'Apple Watch Series 0 (38mm)', suffix: 'ap2300' },
          { name: 'Apple Watch Series 0 (42mm)', suffix: 'ap2301' },
          { name: 'Apple Watch Series SE（第3世代）	 (40mm)', suffix: 'ap2327' },
          { name: 'Apple Watch Series SE（第3世代）	 (44mm)', suffix: 'ap2328' },
          { name: 'Apple Watch Series SE（第2世代）	 (40mm)', suffix: 'ap2320' },
          { name: 'Apple Watch Series SE（第2世代）	 (44mm)', suffix: 'ap2321' },
          { name: 'Apple Watch Series SE（第1世代） (40mm)', suffix: 'ap2314' },
          { name: 'Apple Watch Series SE（第1世代） (44mm)', suffix: 'ap2315' },
          { name: 'Apple Watch Ultra 3 (49mm)', suffix: 'ap2326' },
          { name: 'Apple Watch Ultra 2 (49mm)', suffix: 'ap2325' },
          { name: 'Apple Watch Ultra (49mm)', suffix: 'ap2322' }
        ],
        SS: [
          { name: 'Galaxy Watch 8 (40 mm)', prefix: 'ss2388' },
          { name: 'Galaxy Watch 8 (44 mm)', prefix: 'ss2389' },
          { name: 'Galaxy Watch 8 Classic', prefix: 'ss2390' },
          { name: 'Galaxy Watch 7 (40 mm)', prefix: 'ss2309' },
          { name: 'Galaxy Watch 7 (44 mm)', prefix: 'ss2310' },
          { name: 'Galaxy Watch 6 (40 mm)', prefix: 'ss2305' },
          { name: 'Galaxy Watch 6 (44 mm)', prefix: 'ss2306' },
          { name: 'Galaxy Watch 6 Classic (43mm)', prefix: 'ss2307' },
          { name: 'Galaxy Watch 6 Classic (47mm)', prefix: 'ss2308' },
          { name: 'Galaxy Watch 5 (40 mm)', prefix: 'ss2303' },
          { name: 'Galaxy Watch 5 (44 mm)', prefix: 'ss2304' },
          { name: 'Galaxy Watch 5 Pro (45mm)', prefix: 'ss2302' },
          { name: 'Galaxy Watch FE (40mm)', prefix: 'ss2311' },
          { name: 'Galaxy Watch Ultra (47mm)', prefix: 'ss2312' }
        ],
        GM: [
          { name: 'Fenix 8シリーズ（43mm）', prefix: 'gm2311' },
          { name: 'Fenix 8シリーズ（47mm）', prefix: 'gm2312' },
          { name: 'Fenix 8シリーズ（51mm）', prefix: 'gm2313' },
          { name: 'Fenix 7シリーズ（42mm）', prefix: 'gm2308' },
          { name: 'Fenix 7シリーズ（47mm）', prefix: 'gm2309' },
          { name: 'Fenix 7シリーズ（51mm）', prefix: 'gm2310' },
          { name: 'vivoactive 6（42.2mm）', prefix: 'gm2314' },
          { name: 'Forerunner 570（42mm）', prefix: 'gm2315' },
          { name: 'Forerunner 570（47mm）', prefix: 'gm2316' },
          { name: 'Forerunner 165（43mm）', prefix: 'gm2307' },
          { name: 'Forerunner 265 (46.1mm)', prefix: 'gm2305' },
          { name: 'Forerunner 965 (47.2mm)', prefix: 'gm2306' }
        ]
      }
    },
    'h1_AWCB': {
      brands: ['AP'],
      prefix: 'awcb_awcbtpu_',
      models: [
        { name: 'Apple Watch（38mm〜41mm）', modelCode: 'ap2158' },
        { name: 'Apple Watch（42mm〜45mm）', modelCode: 'ap2159' }
      ]
    },
    'h1_AWLB': {
      brands: ['AP'],
      prefix: 'awlb_awlbvl_',
      models: [
        { name: 'Apple Watch（38mm〜41mm）', modelCode: 'ap2158' },
        { name: 'Apple Watch（42mm〜45mm）', modelCode: 'ap2159' }
      ]
    }
  };

  if (!currentH1Tag || !baseCode) return;

  // 商品タイプ判別
  const isEarphone    = config.earphone.tags.includes(currentH1Tag);
  const isClearBand   = config.clearband.tags.includes(currentH1Tag);
  const isLeatherBand = config.leatherband.tags.includes(currentH1Tag);

  // 対象の itemConfig を決定
  const itemConfig =
    isEarphone    ? config.earphone :
    isClearBand   ? config.clearband :
    isLeatherBand ? config.leatherband :
    config[currentH1Tag];

  // メーカー初期化
  seriesSelector.innerHTML = '<option value="" disabled selected>メーカーを選択</option>';
  itemConfig.brands.forEach(brand => {
    const option = document.createElement('option');
    option.value = brand;
    option.textContent = brand === 'AP' ? 'Apple' : brand === 'SS' ? 'Samsung' : brand === 'GM' ? 'Garmin' : brand;
    seriesSelector.appendChild(option);
  });

  modelSelector.style.display = 'none';
  modelSelector.innerHTML = '';

  seriesSelector.addEventListener('change', function () {
    const selectedBrand = this.value;
    modelSelector.innerHTML = '<option value="" disabled selected>機種を選択してください</option>';

    // イヤホン
    if (isEarphone) {
      const models = itemConfig.models[selectedBrand] || [];
      models.forEach(model => {
        let handle;
        if (selectedBrand === 'AP') {
          handle = `ap_aptpu_cl${baseCode}-${indexNumber}_${model.suffix}`;
        } else if (selectedBrand === 'SS') {
          handle = `${model.prefix}cl${baseCode}-${indexNumber}_n000`;
        }
        const opt = document.createElement('option');
        opt.value = handle;
        opt.textContent = model.name;
        modelSelector.appendChild(opt);
      });
    }

    // クリアバンド / レザーバンド
    else if (isClearBand || isLeatherBand) {
      const useBoth = hasClearSubtype || hasLeatherSubtype;

      // prefix 生成を一箇所にまとめるヘルパー
      const buildHandleForBand = (bandKey, selectedBrand, model) => {
        const def = config[bandKey];
        let handle;

        if (selectedBrand === 'AP') {
          // Apple 用
          let base = def.apHandleBase || '';

          // 新クリアバンド：sc_ck_
          if (bandKey === 'clearband' && hasClearSubtype) {
            base = 'sc_ck_';
          }
          // 新レザーバンド：sl_wk_
          if (bandKey === 'leatherband' && hasLeatherSubtype) {
            base = 'sl_wk_';
          }

          handle = `${base}cl${baseCode}-${indexNumber}_${model.suffix}`;

        } else if (selectedBrand === 'GM') {
          // Garmin用のハンドル生成
          const gmBase = bandKey === 'clearband' ? 'sc_ck_' : 'sl_wk_';
          handle = `${gmBase}cl${baseCode}-${indexNumber}_${model.prefix}`;

        } else if (selectedBrand === 'SS') {
          // Samsung 用
          // ck / wk の新バンドなら、先頭 sc_ck_ / sl_wk_ ＋ suffix（ssコード） にする
          let ssBase = null;
          if (bandKey === 'clearband' && hasClearSubtype) {
            ssBase = 'sc_ck_';
          } else if (bandKey === 'leatherband' && hasLeatherSubtype) {
            ssBase = 'sl_wk_';
          }

          if (ssBase) {
            // 新パターン：sc_ck_ / sl_wk_ + suffix
            handle = `${ssBase}cl${baseCode}-${indexNumber}_${model.prefix}`;
          } else {
            handle = `${model.prefix}cl${baseCode}-${indexNumber}_n000`;
          }
        }

        return handle;
      };

      // m_ck / m_wk 付き → クリア / レザー両方を optgroup で出す
      if (useBoth) {
        // --- クリアバンド側 ---
        if (hasClearSubtype || isClearBand) {
          const cfgClear   = config.clearband;
          const modelsClear = cfgClear.models[selectedBrand] || [];
          if (modelsClear.length) {
            const ogClear = document.createElement('optgroup');
            ogClear.label = 'クリアバンド';

            modelsClear.forEach(model => {
              const handle = buildHandleForBand('clearband', selectedBrand, model);
              const opt = document.createElement('option');
              opt.value = handle;
              opt.textContent = model.name;
              ogClear.appendChild(opt);
            });

            modelSelector.appendChild(ogClear);
          }
        }

        // --- レザーバンド側 ---
        if (hasLeatherSubtype || isLeatherBand) {
          const cfgLeather    = config.leatherband;
          const modelsLeather = cfgLeather.models[selectedBrand] || [];
          if (modelsLeather.length) {
            const ogLeather = document.createElement('optgroup');
            ogLeather.label = 'レザーバンド';

            modelsLeather.forEach(model => {
              const handle = buildHandleForBand('leatherband', selectedBrand, model);
              const opt = document.createElement('option');
              opt.value = handle;
              opt.textContent = model.name;
              ogLeather.appendChild(opt);
            });

            modelSelector.appendChild(ogLeather);
          }
        }
      }

      else {
        const models = itemConfig.models[selectedBrand] || [];
        const bandKey = isClearBand ? 'clearband' : 'leatherband';

        models.forEach(model => {
          const handle = buildHandleForBand(bandKey, selectedBrand, model);
          const opt = document.createElement('option');
          opt.value = handle;
          opt.textContent = model.name;
          modelSelector.appendChild(opt);
        });
      }
    }

    // 既存：AWCB / AWLB
    else if (['h1_AWCB', 'h1_AWLB'].includes(currentH1Tag)) {
      itemConfig.models.forEach(model => {
        const handle = `${itemConfig.prefix}cl${baseCode}-${indexNumber}_${model.modelCode}`;
        const opt = document.createElement('option');
        opt.value = handle;
        opt.textContent = model.name;
        modelSelector.appendChild(opt);
      });
    }

    modelSelector.style.display = 'block';
  });

  modelSelector.addEventListener('change', function () {
    navigateProductByValue(this.value);
  });

  window.fox = window.fox || {};
  window.fox.settings = window.fox.settings || {};
  window.fox.settings.bandConfig = {
    clearband: config.clearband,
    leatherband: config.leatherband
  };
});





document.addEventListener('DOMContentLoaded', function () {
  const productTags = getTagsSafe();
  if (!productTags.length) return;

  if (productTags.includes('h1_LG3') || productTags.includes('h1_LG2')) {
    const seriesSelector = document.querySelector('.series');
    const modelSelector = document.querySelector('.model_selector.models');

    if (!seriesSelector || !modelSelector) return;
    // メーカーはAppleのみ
    seriesSelector.innerHTML = `
      <option value="" disabled selected>メーカーを選択</option>
      <option value="AP">Apple</option>
    `;

    // 初期状態では機種セレクトボックスを非表示に設定
    modelSelector.style.display = 'none';
    modelSelector.innerHTML = '';

    const lensGlassModels = [
      { name: 'iPhone 15', url: 'https://caseplay.shop/collections/h1_lg/products/lg2-ap-ap2221_22-bk?variant=43882521264335' },
      { name: 'iPhone 15 Pro', url: 'https://caseplay.shop/collections/h1_lg/products/lg3-ap-ap2223_24-gy?variant=43882532274383' },
      { name: 'iPhone 15 Plus', url: 'https://caseplay.shop/collections/h1_lg/products/lg2-ap-ap2222_22-bk' },
      { name: 'iPhone 15 Pro Max', url: 'https://caseplay.shop/collections/h1_lg/products/lg3-ap-ap2224_24-gy' },
      { name: 'iPhone 14', url: 'https://caseplay.shop/collections/h1_lg/products/lg2-ap-ap2179_80-bk?variant=43882519298255' },
      { name: 'iPhone 14 Pro', url: 'https://caseplay.shop/collections/h1_lg/products/lg3-ap-ap2181_82-bk?variant=43882530373839' },
      { name: 'iPhone 14 Plus', url: 'https://caseplay.shop/collections/h1_lg/products/lg2-ap-ap2180_80-bk' },
      { name: 'iPhone 14 Pro Max', url: 'https://caseplay.shop/collections/h1_lg/products/lg3-ap-ap2182_82-bk' },
      { name: 'iPhone 13 mini', url: 'https://caseplay.shop/collections/h1_lg/products/lg2-ap-ap2110_11-bk?variant=43882517463247' },
      { name: 'iPhone 13', url: 'https://caseplay.shop/collections/h1_lg/products/lg2-ap-ap2111_11-bk?variant=44283810513103' },
      { name: 'iPhone 13 Pro', url: 'https://caseplay.shop/collections/h1_lg/products/lg3-ap-ap2112_13-bk?variant=43882528342223' },
      { name: 'iPhone 13 Pro Max', url: 'https://caseplay.shop/collections/h1_lg/products/lg3-ap-ap2113_13-bk' }
    ];

    // メーカー選択時のイベント
    seriesSelector.addEventListener('change', function () {
      modelSelector.innerHTML = '<option value="" disabled selected>機種を選択してください</option>';

      lensGlassModels.forEach(model => {
        const option = document.createElement('option');
        option.value = model.url;
        option.textContent = model.name;
        modelSelector.appendChild(option);
      });

      modelSelector.style.display = 'block';
    });

    modelSelector.addEventListener('change', function () {
      navigateProductByValue(this.value);
    });
  }
});





//液晶保護ガラスの機種を選ぶコード
document.addEventListener('DOMContentLoaded', function () {
  const productTags = getTagsSafe();
  if (!productTags.length) return;

  if (productTags.includes('h1_PG')) {
    const seriesSelector = document.querySelector('.series');
    const modelSelector = document.querySelector('.model_selector.models');

    // メーカーを全て表示
    seriesSelector.innerHTML = `
      <option value="" disabled selected>メーカーを選択</option>
      <option value="AP">Apple</option>
      <option value="GG">Google</option>
      <option value="SS">Samsung</option>
      <option value="SN">Sony</option>
      <option value="SH">SHARP</option>
      <option value="OP">OPPO</option>
      <option value="XM">Xiaomi</option>
      <option value="MT">Motorola</option>
      <option value="FC">FCNT</option>
      <option value="ZT">ZTE</option>
      <option value="HW">HUAWEI</option>
    `;

    // 初期状態では非表示に設定
    modelSelector.style.display = 'none';
    modelSelector.innerHTML = '';

    // 機種オプション生成処理（valueをpg-cl-[メーカー]-[機種コード]-11に設定）
    const setModelOptions = (brandCode) => {
      modelSelector.innerHTML = '<option value="" disabled selected>機種を選択してください</option>';

      const optgroup = document.createElement('optgroup');
      optgroup.label = seriesSelector.querySelector(`option[value="${brandCode}"]`).innerText;

      // メーカーコードに基づく機種データの取得
      const models = window.fox.settings.model_groups.find(group => group.code === brandCode).code_sort;

      models.forEach(modelCode => {
        const modelName = window.fox.settings.model[modelCode];
        if (modelName) {
          const option = document.createElement('option');

          // value値を "pg-cl-[メーカーコード]-[機種コード]-11" の形に設定
          option.value = `pg-cl-${brandCode}-${modelCode.toLowerCase()}-11`;
          option.innerText = modelName;
          optgroup.appendChild(option);
        }
      });

      modelSelector.appendChild(optgroup);
      modelSelector.style.display = 'block';
    };

    // メーカー選択時の動作
    seriesSelector.addEventListener('change', function () {
      setModelOptions(this.value);
    });

    modelSelector.addEventListener('change', function () {
      navigateProductByValue(this.value);
    });
  }
  setupModelFiltering();
});

// -------------------------------------------------------
// すべての「機種セレクト」に対して共通の遷移ロジックを適用
// （スマホケース / バンド / イヤホン / PG / LG すべて対応）
// -------------------------------------------------------
$(function () {
  $(document)
    .off('change.modelNavigate', '.model_selector.models')
    .on('change.modelNavigate', '.model_selector.models', function () {
      navigateProductByValue(this.value);
    });
});

document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('.js-section-product') || document;
  var thumbs = root.querySelector('.js-product-thumbnails-container');
  if (!thumbs) return;

  thumbs.addEventListener('click', function (e) {
    var img = e.target.closest('img');
    if (!img) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    var slide = img.closest('.slick-slide');
    if (!slide || slide.classList.contains('slick-cloned')) return;

    var idx = Number(slide.getAttribute('data-slick-index'));
    if (Number.isNaN(idx)) return;

    var $main = $(root).find('[data-product-images]');
    if (!$main.length || !$main.hasClass('slick-initialized')) return;

    var slick = $main.slick('getSlick');
    var count = slick && slick.slideCount ? slick.slideCount : null;
    if (!count) return;

    idx = ((idx % count) + count) % count;
    $main.slick('slickGoTo', idx, true);
  }, true);
});